import * as React from 'react'
import { createContainer } from 'unstated-next'

import type { GetAdminMeResponse } from '@admin/gen_proto/api_proto/v1/admin_pb'

interface InitialStateType {
  admin: null | GetAdminMeResponse
}

const initialState = {
  admin: null,
} as const

const useAppState = (state: InitialStateType = initialState) => {
  const [admin, updateAdmin] = React.useState<InitialStateType['admin']>(
    state.admin ?? initialState.admin,
  )

  return {
    admin,
    updateAdmin,
  }
}

export const AppStateContainer = createContainer(useAppState)
